import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loadCampaignItemEditPage,
  unLoadCampaignItemEditPage,
  addCampaignItem
} from "../../redux/actions/asset.actions";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import * as DateHelper from "../../utils/date.formatter";
import CampaignItemEditList from "../../components/CampaignItemEditList";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";
import Select from "react-select";
import * as _ from "lodash";
import ListErrors from "../../components/ListErrors";

function ItemsEdit({}) {
  let { key } = useParams();
  const asset = useSelector(state => state.asset);
  const common = useSelector(state => state.common);
  const dispatch = useDispatch();
  const [assetOptions, setAssetOptions] = useState(null);
  const [assetKey, setAssetKey] = useState("");

  const formSelectStyles = {
    control: styles => ({
      ...styles,
      border: "none",
      borderRadius: 0,
      background: "#f3f3f3",
      fontSize: "1rem"
    })
  };

  useEffect(() => {
    dispatch(loadCampaignItemEditPage(key));
    return () => dispatch(unLoadCampaignItemEditPage());
  }, [key]);

  useEffect(() => {
    if (asset.campaign && asset.assets) {
      const assets = _.filter(asset.assets, { site: asset.campaign.site });
      let options = [];
      const items = asset.campaign.items;
      for (let i in assets) {
        const exists = _.find(items, { asset_key: assets[i].key });
        if (!exists) {
          options.push({
            value: asset.assets[i].key,
            label: asset.assets[i].name
          });
        }
      }
      setAssetOptions(options);
    }
  }, [asset]);

  useEffect(() => {
    dispatch(loadCampaignItemEditPage(key));
  }, [common.redirectTo]);

  const handleAddItem = () => ev => {
    ev.preventDefault();
    dispatch(addCampaignItem(key, assetKey));
  };

  if (!asset.campaign) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"campaigns"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  const campaign = asset.campaign;

  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"campaigns"} />
          <div id="content">
            <Header />
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/campaigns/${campaign.key}`}
                >
                  {t("common.back")}
                </Link>
                <h2>{t("campaign.items")}</h2>
              </div>
              <div className={`form-item`}>
                <label htmlFor="name">{t("campaign.items")}</label>
                <Select
                  closeMenuOnSelect={true}
                  options={assetOptions}
                  onChange={e => setAssetKey(e.value)}
                  styles={formSelectStyles}
                />
              </div>
              <ListErrors errors={asset.errors} />
              <div className="form-item">
                <button type="button" onClick={handleAddItem()}>
                  {t("campaign.item_add_button")}
                </button>
              </div>
            </div>
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <h2>{t("campaign.items_title")}</h2>
              </div>
              <CampaignItemEditList data={campaign.items} />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default ItemsEdit;
